import React from 'react';

const LSATUpsellContent: React.FC = (props) => {
  return (
    <ul className="u-padding-L-m">
      <li>Comprehensive prep for the LSAT</li>
      <li>7000+ official LSAT questions</li>
      <li>Explanation videos from expert tutors</li>
      <li>Practice tests</li>
      <li>Customizable study schedules</li>
      <li>Score improvement guaranteed</li>
    </ul>
  );
};

export default LSATUpsellContent;
